export default "__VITE_ASSET__CDAmXmmF__"